import React from "react";

import TextInput from '../../components/form/TextInput';
import SelectAjax from "../../components/form/SelectAjax";
import Random from "../../utils/strings/Random";
import ReactDOM from "react-dom";
import Ws from '../../config/Ws';
import Listagem from "../blocos/Listagem";
import Alert from "../../components/alert/Alert";
import SimpleAlert from "../../components/alert/types/SimpleAlert";
import TextArea from "../../components/form/TextArea";
import STRINGS from './../../data/language/language';

class Component extends React.Component {
  constructor(props){
    super(props);

    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.removeItemList = this.removeItemList.bind(this);
    this.state = {
      strings:STRINGS[window.LANGUAGE],
      wrapper:Random(7),
      listagemClass:"listagem",
      itemClass:"item-listagem",
      exercicios: props.exercicios ? props.exercicios : [],
      detalhe: props.detalhe ? props.detalhe : {}
    };
  }

  componentDidMount() {

  }

  componentWillUnmount() {

  }

  removeItemList (e){
    e.preventDefault();

   const _item = e.target.closest("."+this.state.itemClass);
    const _id = _item.getAttribute("data-id");

    var array = [...this.state.detalhe.exercicios]; // make a separate copy of the array
    array.map((value,i)=>{
      if(value.value==_id){
        array.splice(i,1);
        let detalhe = {...this.state.detalhe};
        detalhe.exercicios = array
        this.setState({detalhe: detalhe});
      }
    });
  }

  handleSelectChange = (newValue) => {
    var check;
    var exercicios = [];

    const { atencao, exerciciosJaAdiconado } = this.state.strings;

    if(this.state.detalhe && this.state.detalhe.exercicios){
      //checa se o exercício já foi adicionado na listagem
      this.state.detalhe.exercicios.map((item,i)=>{
        if(newValue.value==item.value){
          check = true;
        }
      });
      exercicios = this.state.detalhe.exercicios;
    }

    if(!check){
      const detalhe = {...this.state.detalhe};
      const exerciciosModificados = [...exercicios, newValue];
      detalhe.exercicios = exerciciosModificados;
      this.setState({detalhe: detalhe});
    }else{
      let modal = new Alert();
      modal.open(
        {
          page:
          <SimpleAlert
            title={atencao}
            message={exerciciosJaAdiconado} />,
          animation:Alert.ANIMATION_INCREASE
        });
    }
  };

  render (){
    //--------------------------------
    const exercicios = this.state.detalhe ? this.state.detalhe.exercicios : [];
    const {cadencia,repeticoes,intervalo,dias_semana,id} = this.state.detalhe ? this.state.detalhe : {};
    const observacoesBloco = this.props.detalhe ? this.props.detalhe.observacoes : '';

    const
    {
      observacoes,
      cadenciaTitle,
      intervaloTitle,
      seriesRepeticoes,
      digiteAqui,
      selecioneExercicios,
      diaSemanaTitle,
      nenhumItem
    } = this.state.strings;

    const search = {genero:this.props.sexo ? this.props.sexo.toUpperCase() : '' };

    //--------------------------------
    return(
      <div id={this.state.wrapper}>
        <a data-position={this.props.position} onClick={this.props.onRemoveHandler} href='#' className='buton-remove-bloco js-remove-bloco--bloco buton-remove-bloco--bloco'><i className="fas fa-times"></i></a>
        <input type='hidden' name='id' value={id} />
        <div className="">
          <TextArea
            name="observacoes"
            title={observacoes}
            value={observacoesBloco}
            placeholder="">
          </TextArea>
        </div>

        <div className="pure-u-15-24">
          <SelectAjax
            data={search}
            noResultsText={nenhumItem}
            onChange={this.handleSelectChange}
            url={Ws.exercicios.search}
            title={selecioneExercicios} />
        </div>

        <br />
        <div className="separador"></div>
        <div className="listagem">
          <Listagem
            btRemoveClick={this.removeItemList}
            exercicios={exercicios}>
          </Listagem>
        </div>
      </div>
    )
  }
}

export default Component;



// WEBPACK FOOTER //
// ./src/classes/treino-domiciliar/Component.js